import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';

export const isPersonalDataTwoAdvantagesView = (): boolean =>
  !isMobileOrTablet();

export const isPersonalDataWithoutEncouragementView = (): boolean =>
  isMobileOrTablet();

export const isPersonalDataRedesignActive = (): boolean =>
  isPersonalDataTwoAdvantagesView() || isPersonalDataWithoutEncouragementView();
